module.exports = __webpack_public_path__ + "img/shop_btn.3a1282f6.png";